var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.__(_vm.title)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('v-skeleton-loader',{staticClass:"ml-auto",attrs:{"loading":_vm.loading,"type":"text","max-width":"40"}},[(_vm.currency)?_c('span',[_vm._v(_vm._s(_vm._f("currency")(_vm.value)))]):_c('span',[_vm._v(_vm._s(_vm.value))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }